// ─── Ingrédients d'une recette/repas MIS À L'ÉCHELLE — module PUR ──
// Sert à remplir la liste de courses pour N personnes, sans dépendre de
// Firestore. Reprend le principe de mise à l'échelle de services/personnes.js
// (même vocabulaire que MoPCal-v3 services/repas.js `_accIngredients`).
// Extension `.js` explicite : Metro s'en passe, Node (donc `npm test`) l'exige.
import { personnesRecette, personnesRepas } from './personnes.js';

// Quantité numérique en tête d'une chaîne (« 250 », « 1,5 » → 1.5). NaN sinon
// (ex. « au goût », texte libre) — la quantité reste alors telle quelle.
function quantiteNum(q) {
  const m = String(q || '').replace(',', '.').match(/-?\d+(\.\d+)?/);
  return m ? parseFloat(m[0]) : NaN;
}
function arrondir(n) { return Math.round(n * 100) / 100; }

function mettreALEchelle(ingredients, facteur) {
  return (ingredients || []).filter(i => (i.nom || '').trim()).map(i => {
    const qn = quantiteNum(i.quantite);
    return {
      nom: i.nom.trim(),
      unite: (i.unite || '').trim(),
      quantite: isNaN(qn) ? (i.quantite || '') : String(arrondir(qn * facteur)),
    };
  });
}

// Ingrédients d'UNE recette, mis à l'échelle pour `personnesCibles`.
export function ingredientsRecetteEchelle(recette, personnesCibles) {
  const Rp = personnesRecette(recette);
  const facteur = Math.max(0, Number(personnesCibles) || Rp) / Rp;
  return mettreALEchelle(recette?.ingredients, facteur);
}

// Ingrédients d'UN repas (ses recettes + ses extras), mis à l'échelle pour
// `personnesCibles`. `recettesById` : { [id]: recette }.
export function ingredientsRepasEchelle(repas, recettesById, personnesCibles) {
  const M = personnesRepas(repas);
  const ratio = Math.max(0, Number(personnesCibles) || M) / M;
  const out = [];
  for (const x of (repas?.recettes || [])) {
    const rec = recettesById?.[x.recetteId];
    if (!rec) continue;
    const R = Math.max(1, Number(x.personnes) || M);
    const Rp = personnesRecette(rec);
    out.push(...mettreALEchelle(rec.ingredients, (R / Rp) * ratio));
  }
  out.push(...mettreALEchelle(repas?.extras, ratio));
  return out;
}
